module.exports = __webpack_public_path__ + "img/welcome.3c3d1b6c.png";